// extracted by mini-css-extract-plugin
export default {"body":"APICallsHistory_body__vLl0K","notFound":"APICallsHistory_notFound__jauc1","pagination":"APICallsHistory_pagination__VHOQj","searchInput":"APICallsHistory_searchInput__OogjB"};